import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types";
import {
  XAICall,
  XAICallLog,
  XAICallLogsDashboardResponse,
  XAICallModel,
  XAILead,
  XAILeadsDashboardResponse,
} from "@lib/types/xAI";

type XAIDashboardParams = {
  timeFrom: string;
  timeTo: string;
};

export const apiGetXAICallLogsDashboard = async (
  params: XAIDashboardParams,
) => {
  const url = `/x-ai-call-log/dashboard`;
  return API.post<XAICallLogsDashboardResponse>(url, { params });
};

export const apiGetXAILeadsDashboard = async (params: XAIDashboardParams) => {
  const url = `/x-ai-call-lead/dashboard`;
  return API.post<XAILeadsDashboardResponse>(url, { params });
};

//

export const apiGetXAILeads = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/x-ai-call-lead` });
  return API.get<PaginationType<XAILead>>(url);
};

export const apiDeleteXAILead = async (leadId: string) => {
  const url = `/x-ai-call-lead/${leadId}`;
  return API.delete<void>(url);
};

export const apiUpdateXAILead = async (lead: Partial<XAILead>) => {
  const { id } = lead;
  const url = `/x-ai-call-lead/${id}`;
  return API.patch<XAILead>(url, lead);
};

export const apiGetXAILead = async (leadId: string) => {
  const url = `/x-ai-call-lead/${leadId}`;
  return API.get<XAILead>(url);
};

export const apiGetXAICalls = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/x-ai-call-log` });
  return API.get<PaginationType<XAICall>>(url);
};

export const apiGetXAICall = async (callLogId: string, params?: ApiParams) => {
  const url = ApiUrlPrepare({ params, url: `/x-ai-call-log/${callLogId}` });
  return API.get<XAICall>(url);
};

export const apiGetXAICallLogs = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/x-ai-call-history` });
  return API.get<PaginationType<XAICallLog>>(url);
};

export const apiGetXAICallLog = async (callId: string) => {
  const url = `/x-ai-call-history/${callId}`;
  return API.get<XAICallLog>(url);
};

/**
 * XAI Call Model
 */
export const apiGetXAICallModels = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/x-ai-call-model` });
  return API.get<PaginationType<XAICallModel>>(url);
};

export const apiGetXAICallModel = async (modelId: string) => {
  const url = `/x-ai-call-model/${modelId}`;
  return API.get<XAICallModel>(url);
};

export const apiCreateXAICallModel = async (model: XAICallModel) => {
  const url = `/x-ai-call-model`;
  return API.post<XAICallModel>(url, model);
};

export const apiUpdateXAICallModel = async (model: Partial<XAICallModel>) => {
  const { id } = model;
  const url = `/x-ai-call-model/${id}`;
  return API.patch<XAICallModel>(url, model);
};

export const apiDeleteXAICallModel = async (modelId: string) => {
  const url = `/x-ai-call-model/${modelId}`;
  return API.delete<void>(url);
};

export const apiBulkCreateXAICallModels = async (models: XAICallModel[]) => {
  const url = `/x-ai-call-model/bulk`;
  return API.post<XAICallModel[]>(url, models);
};

export const apiBulkUpdateXAICallModels = async (
  models: Partial<XAICallModel>[],
) => {
  const url = `/x-ai-call-model/bulk`;
  return API.patch<XAICallModel[]>(url, { bulk: models });
};
